
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/welfare",
      function () {
        return require("private-next-pages/welfare/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/welfare"])
      });
    }
  